// 引入组件
import headComponent from "components/content/Header";
import footComponent from "components/content/Footer";
export default {
	headComponent,
	footComponent
}
